// extracted by mini-css-extract-plugin
module.exports = {"paymentTrigger":"pricing-module--paymentTrigger--uEOec","paymentButton":"pricing-module--paymentButton--21twD","current":"pricing-module--current--32Zwq"};